<div *ngIf="isOpen"
    class="fixed inset-0 bg-slate-900/40 backdrop-blur-md z-[70] flex items-center justify-center p-4 transition-opacity duration-300 animate-fade-in"
    (click)="closeModal()">

    <!-- Modal Container -->
    <div (click)="$event.stopPropagation()"
        class="bg-white/95 dark:bg-slate-900/95 w-full max-w-md rounded-[24px] shadow-[0_20px_60px_-15px_rgba(0,0,0,0.3)] border border-white/50 dark:border-slate-800/50 flex flex-col overflow-hidden backdrop-blur-xl animate-fade-in-up">

        <!-- Header -->
        <div class="flex-none px-5 py-4 border-b border-slate-200/50 dark:border-slate-800/50 flex justify-between items-center bg-transparent gap-4">
            <div>
                <h2 class="text-lg md:text-xl font-black text-slate-800 dark:text-white flex items-center gap-2.5 tracking-tight">
                    <span class="material-icons text-amber-500 text-2xl">add_box</span>
                    เพิ่มทะเบียนรถใหม่
                </h2>
                <p class="text-sm text-slate-500 dark:text-slate-400 mt-0.5 font-medium">ระบุข้อมูลรถเพื่อบันทึกในระบบ</p>
            </div>
            <button (click)="closeModal()"
                class="w-10 h-10 flex items-center justify-center rounded-full bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-500 dark:text-slate-400 transition-colors shadow-sm cursor-pointer">
                <span class="material-icons text-xl">close</span>
            </button>
        </div>

        <!-- Body -->
        <div class="px-5 py-6 space-y-5 bg-slate-50/30 dark:bg-slate-900/30 overflow-y-auto max-h-[70vh] custom-scrollbar"
             (click)="closeDropdowns()">

            <!-- Plate Number -->
            <div class="animate-fade-in-up" style="animation-delay: 0.1s;">
                <label class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
                    เลขทะเบียน <span class="text-rose-500">*</span>
                </label>
                <div class="relative group">
                    <span class="absolute left-3.5 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-lg group-focus-within:text-amber-500 transition-colors">tag</span>
                    <input type="text" [(ngModel)]="plateNumber" placeholder="เช่น กก 9999" maxlength="8"
                        class="w-full pl-11 pr-4 py-2.5 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 rounded-xl focus:ring-4 focus:ring-amber-500/10 focus:border-amber-400 dark:focus:border-amber-500 outline-none transition-all text-slate-700 dark:text-slate-200 text-sm font-bold placeholder:text-slate-400 placeholder:font-medium">
                </div>
            </div>

            <!-- Province -->
            <div class="animate-fade-in-up" style="animation-delay: 0.15s;">
                <label class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
                    จังหวัด <span class="text-rose-500">*</span>
                </label>
                <ng-container *ngTemplateOutlet="selectField; context: { 
                    label: 'จังหวัด', 
                    key: 'provinces', 
                    options: provinceOptions, 
                    selected: provinceId, 
                    icon: 'map', 
                    placeholder: '-- เลือกจังหวัด --'
                }"></ng-container>
            </div>

            <!-- Vehicle Type -->
            <div class="animate-fade-in-up" style="animation-delay: 0.2s;">
                <label class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
                    ประเภทรถ <span class="text-rose-500">*</span>
                </label>
                <ng-container *ngTemplateOutlet="selectField; context: { 
                    label: 'ประเภทรถ', 
                    key: 'vehicleTypes', 
                    options: vehicleTypeOptions, 
                    selected: vehicleTypeId, 
                    icon: 'directions_car', 
                    placeholder: '-- เลือกประเภทรถ --',
                    disabled: true
                }"></ng-container>
            </div>
        </div>

        <!-- Footer -->
        <div class="flex-none px-6 py-4 bg-white dark:bg-slate-900 border-t border-slate-200/50 dark:border-slate-800/50 flex justify-end gap-3 z-10">
            <button (click)="closeModal()"
                class="px-5 py-2.5 text-sm font-bold text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl transition-all cursor-pointer">
                ยกเลิก
            </button>
            <button (click)="onSave()" [disabled]="isLoading"
                class="px-8 py-2.5 text-sm font-black bg-amber-400 hover:bg-amber-500 text-amber-900 rounded-xl shadow-lg shadow-amber-400/30 transition-all transform hover:-translate-y-0.5 cursor-pointer active:translate-y-0 uppercase tracking-wider disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-none min-w-[140px]">
                
                <span *ngIf="!isLoading">บันทึกข้อมูล</span>

                <div *ngIf="isLoading" class="flex items-center justify-center gap-2">
                    <svg class="animate-spin h-4 w-4 text-amber-900" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span>กำลังบันทึก...</span>
                </div>
            </button>
        </div>
    </div>
</div>

<!-- REUSABLE DROPDOWN TEMPLATE -->
<ng-template #selectField let-label="label" let-key="key" let-options="options" let-selected="selected" let-icon="icon"
    let-placeholder="placeholder" let-disabled="disabled">
    <div class="relative w-full" (click)="$event.stopPropagation()">
        <!-- Selected Value Display -->
        <button type="button" (click)="!disabled && toggleDropdown(key, $event)" [disabled]="disabled"
            class="w-full flex items-center justify-between px-4 py-2.5 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 rounded-xl outline-none transition-all duration-200 group relative"
            [ngClass]="{
                'ring-4 ring-amber-500/10 border-amber-400 dark:border-amber-500 shadow-sm': openDropdown === key,
                'hover:border-amber-300 dark:hover:border-amber-500/50': !disabled && openDropdown !== key,
                'bg-amber-50/30 dark:bg-amber-900/10 border-amber-200 dark:border-amber-800 cursor-not-allowed': disabled,
                'cursor-pointer': !disabled
            }">

            <div class="flex items-center gap-3 overflow-hidden mr-6">
                <span class="material-icons text-[20px] transition-colors duration-300"
                      [ngClass]="{
                          'text-amber-500': selected || disabled,
                          'text-slate-400 group-hover:text-amber-400': !selected && !disabled
                      }">
                    {{ icon }}
                </span>
                <span class="text-sm font-bold truncate tracking-tight"
                    [ngClass]="{
                        'text-slate-800 dark:text-slate-100': selected || disabled,
                        'text-slate-400': !selected && !disabled
                    }">
                    {{ getOptionName(key, selected) || placeholder }}
                </span>
            </div>

            <!-- Arrow Icon (Hide if disabled to match other designs if requested, but keeping for clarity now) -->
            <span *ngIf="!disabled" class="material-icons text-[20px] text-slate-400 transition-transform duration-300 absolute right-3"
                [ngClass]="{ 'rotate-180 text-amber-500': openDropdown === key }">
                expand_more
            </span>
        </button>

        <!-- Dropdown Options Menu -->
        <div *ngIf="openDropdown === key && !disabled"
            class="absolute z-[100] mt-2 w-full bg-white dark:bg-slate-800 rounded-2xl shadow-[0_15px_50px_-10px_rgba(0,0,0,0.25)] border border-slate-100 dark:border-slate-700/80 py-2 animate-fade-in divide-y divide-slate-50 dark:divide-slate-700/50 max-h-60 overflow-y-auto custom-scrollbar">

            <div *ngIf="options.length === 0" class="px-4 py-10 text-center opacity-40">
                <span class="material-icons text-3xl mb-2">inventory_2</span>
                <p class="text-[11px] font-bold uppercase tracking-widest">ไม่มีข้อมูล</p>
            </div>

            <button *ngFor="let opt of options" type="button" (click)="selectOption(key, opt.value)"
                class="w-full flex items-center justify-between px-4 py-3 hover:bg-amber-50 dark:hover:bg-amber-900/20 text-left transition-all group">
                <span class="text-[13px] font-bold transition-colors"
                    [ngClass]="selected === opt.value ? 'text-amber-600 dark:text-amber-400' : 'text-slate-600 dark:text-slate-300 group-hover:text-amber-600'">
                    {{ opt.label }}
                </span>
                <div *ngIf="selected === opt.value" class="w-5 h-5 rounded-full bg-amber-500 flex items-center justify-center shadow-sm animate-scale-up">
                    <span class="material-icons text-white text-[12px]">check</span>
                </div>
            </button>
        </div>
    </div>
</ng-template>